module.exports = __webpack_public_path__ + "media/images/gabigol-e1c0fff49c4520e203967b91baa3e28d.jpg";